import { Button, ThemeProvider } from '@mui/material'
import React from 'react'
import modeButtonTheme from './modeButtonTheme'

export default function CustomNewButton({label,onClick,disabled,size}) {
  return (
   <ThemeProvider theme={modeButtonTheme}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{ color: "white" }}
                                    onClick={onClick}
                                    disabled={disabled}
                                    size={size?size:"medium"}
                                  >
                                   {label}
                                  </Button>
                                </ThemeProvider>
  )
}
